module.exports = __webpack_public_path__ + "img/image115.074afd7a.jpg";